module.exports = __webpack_public_path__ + "static/media/krb.32f253ed.svg";